import { ReactNode } from 'react';
import { Flex } from '@mantine/core';
import {
	StepTabContainer,
	Header,
	SubHeader,
	TextContainer,
} from '@dealstack/frontend/shared/components/StepTab/styled';

interface Props {
	header: string;
	subHeader: string;
	isActive: boolean;
	icon?: React.ReactElement;
	onClick?: () => void;
	statusNode?: ReactNode;
}

/**
 * used to dispay in what step the user is in the upload process
 */
export const StepTab = ({ header, subHeader, isActive, icon, onClick, statusNode }: Props) => {
	return (
		<StepTabContainer $isActive={isActive} onClick={() => onClick?.()}>
			<TextContainer>
				<Flex align="center" gap="0.5rem">
					{icon}
					<Header>{header}</Header>
				</Flex>
				<SubHeader>{subHeader}</SubHeader>
			</TextContainer>

			{statusNode && (
				<Flex mt="auto" pt="0.25rem">
					{statusNode}
				</Flex>
			)}
		</StepTabContainer>
	);
};
